export default "__VITE_ASSET__5_UugU41__"